.ConfigTable {
  flex-grow: 1;
}
